export default __webpack_public_path__ + "static/media/Vazir-Medium.43e6c88c.eot";